import React from "react";
export const SignOutIcon = () => {
  return (
    <svg width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.21403 22.0009C2.89385 22.0055 2.57614 21.9444 2.28049 21.8214C1.98484 21.6984 1.71752 21.5162 1.49502 21.2859C1.2647 21.0635 1.08243 20.7961 0.959456 20.5005C0.83648 20.2048 0.775415 19.8871 0.780028 19.5669V14.6979H3.21403V19.5669H20.255V2.52593H3.21403V7.39495H0.780028V2.52593C0.775534 2.20576 0.836655 1.8881 0.959624 1.59246C1.08259 1.29681 1.2648 1.02947 1.49502 0.806933C1.71756 0.576708 1.98489 0.394501 2.28053 0.271532C2.57617 0.148563 2.89386 0.0874112 3.21403 0.0919057H20.255C20.5752 0.0874112 20.8929 0.148563 21.1885 0.271532C21.4842 0.394501 21.7515 0.576708 21.974 0.806933C22.2043 1.02947 22.3865 1.29681 22.5094 1.59246C22.6324 1.8881 22.6935 2.20576 22.689 2.52593V19.5669C22.6936 19.8871 22.6326 20.2048 22.5096 20.5005C22.3866 20.7961 22.2043 21.0635 21.974 21.2859C21.7515 21.5162 21.4842 21.6984 21.1886 21.8214C20.8929 21.9444 20.5752 22.0055 20.255 22.0009H3.21403ZM9.90903 17.1319L8.20903 15.3669L11.309 12.267H0.780028V9.83196H11.309L8.20903 6.73192L9.90903 4.96691L15.995 11.0529L9.90903 17.1319Z"
        fill="#333333"
      />
    </svg>
  );
};

export const CloseIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      className="bi bi-x-lg"
      viewBox="0 0 16 16"
    >
      <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z" />
    </svg>
  );
};

export const NoDataImage = () => {
  return (
    <svg width="345" height="287" viewBox="0 0 345 287" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_3694_8732)">
        <g filter="url(#filter0_d_3694_8732)">
          <path
            d="M153.54 54.5382C153.473 54.5382 153.406 54.5358 153.339 54.5316C148.913 54.2473 133.77 52.1057 124.726 36.4726C124.058 35.3187 124.19 33.8504 125.055 32.8199C132.607 26.6791 138.507 20.033 141.989 12.6482C142.618 11.899 143.562 11.4895 144.517 11.5064C145.498 11.5295 146.401 11.9912 146.997 12.7729C151.29 18.4135 159.767 28.3988 168.297 31.8997C169.255 32.2936 169.949 33.0927 170.201 34.0937C170.45 35.0862 170.219 36.1094 169.567 36.9008L156.001 53.3699C155.391 54.1106 154.483 54.5382 153.54 54.5382Z"
            fill="#E6E6E6"
          />
          <path
            d="M127.854 33.8121C127.623 34.0879 127.581 34.4812 127.749 34.792C135.931 49.8536 150.558 51.0352 153.407 51.1189C153.682 51.1346 153.939 51.0111 154.113 50.7997L167.582 34.4493C167.773 34.2174 167.831 33.9217 167.744 33.6362C167.655 33.3496 167.438 33.1358 167.147 33.0515C157.999 30.3787 148.401 17.9989 145.677 14.2679C145.518 14.0499 145.272 13.9192 145.003 13.9102C144.726 13.9075 144.474 14.0162 144.297 14.2258C140.4 21.8228 134.943 28.3679 127.854 33.8121Z"
            fill="white"
          />
          <path
            d="M134.637 37.3389L146.846 24.8935C147.681 24.0427 146.373 22.7334 145.537 23.5853L133.328 36.0307C132.494 36.8814 133.801 38.1907 134.637 37.3389Z"
            fill="#E6E6E6"
          />
          <path
            d="M142.006 40.8469C145.375 37.8275 148.304 34.3315 150.701 30.4953C151.334 29.4827 149.734 28.5529 149.103 29.5615C146.785 33.2703 143.955 36.6199 140.697 39.5387C139.809 40.335 141.121 41.6399 142.006 40.8469Z"
            fill="#E6E6E6"
          />
          <path
            d="M148.648 45.0439C151.715 41.6463 154.327 37.8545 156.383 33.7643C156.916 32.7032 155.32 31.7653 154.785 32.8305C152.799 36.7824 150.304 40.4523 147.339 43.7356C146.543 44.6175 147.847 45.9299 148.648 45.0439Z"
            fill="#E6E6E6"
          />
        </g>
        <g filter="url(#filter1_d_3694_8732)">
          <path
            d="M164.643 59.4718C164.576 59.4718 164.509 59.4694 164.442 59.4652C160.017 59.1809 144.874 57.0393 135.83 41.4062C135.162 40.2522 135.294 38.784 136.158 37.7535C143.334 31.5317 148.736 24.7282 153.093 17.5818C153.722 16.8326 154.666 16.4231 155.621 16.44C156.601 16.4631 157.505 16.9248 158.1 17.7065C162.394 23.3471 170.871 33.3324 179.4 36.8333C180.359 37.2272 181.053 38.0263 181.304 39.0273C181.554 40.0198 181.323 41.043 180.671 41.8344L167.105 58.3034C166.495 59.0442 165.586 59.4718 164.643 59.4718Z"
            fill="#E6E6E6"
          />
          <path
            d="M138.958 38.7457C138.727 39.0215 138.685 39.4148 138.853 39.7256C147.035 54.7872 161.662 55.9688 164.511 56.0525C164.785 56.0682 165.042 55.9447 165.216 55.7333L178.686 39.3829C178.876 39.151 178.935 38.8553 178.847 38.5698C178.759 38.2832 178.541 38.0694 178.25 37.9851C169.103 35.3123 159.505 22.9325 156.781 19.2015C156.621 18.9835 156.375 18.8528 156.106 18.8438C155.829 18.8411 155.577 18.9498 155.401 19.1594C150.732 26.9152 145.48 33.7903 138.958 38.7457Z"
            fill="white"
          />
          <path
            d="M145.74 42.2725L157.95 29.8271C158.784 28.9763 157.477 27.667 156.641 28.5188L144.432 40.9643C143.597 41.815 144.905 43.1243 145.74 42.2725Z"
            fill="#E6E6E6"
          />
          <path
            d="M153.109 45.7805C156.479 42.7611 159.407 39.265 161.805 35.4289C162.438 34.4163 160.837 33.4865 160.207 34.4951C157.889 38.2039 155.058 41.5535 151.801 44.4722C150.912 45.2686 152.224 46.5735 153.109 45.7805Z"
            fill="#E6E6E6"
          />
          <path
            d="M159.751 49.9775C162.819 46.5799 165.43 42.7881 167.486 38.6979C168.02 37.6368 166.424 36.6989 165.888 37.7641C163.902 41.716 161.407 45.3859 158.443 48.6692C157.646 49.5511 158.951 50.8635 159.751 49.9775Z"
            fill="#E6E6E6"
          />
        </g>
        <g filter="url(#filter2_d_3694_8732)">
          <path
            d="M286.164 174.179C286.097 174.179 286.03 174.176 285.963 174.172C281.538 173.888 266.395 171.746 257.351 156.113C256.683 154.959 256.815 153.491 257.679 152.461L274.614 132.289C275.243 131.54 276.187 131.13 277.142 131.147C278.122 131.17 279.381 131.461 279.621 132.414C281.572 140.155 289.974 150.207 300.921 151.54C301.95 151.666 302.574 152.733 302.825 153.734C303.075 154.727 302.844 155.75 302.192 156.541L288.626 173.01C288.016 173.751 287.107 174.179 286.164 174.179Z"
            fill="#E6E6E6"
          />
          <path
            d="M260.479 153.453C260.248 153.729 260.206 154.122 260.374 154.433C268.556 169.494 283.183 170.676 286.032 170.76C286.306 170.775 286.563 170.652 286.737 170.44L300.207 154.09C300.397 153.858 300.456 153.562 300.368 153.277C300.28 152.99 300.074 152.706 299.771 152.692C288.127 152.146 278.775 139.557 278.302 133.909C278.279 133.64 277.896 133.56 277.627 133.551C277.35 133.548 277.098 133.657 276.922 133.866L260.479 153.453Z"
            fill="white"
          />
          <path
            d="M267.261 156.98L279.47 144.534C280.305 143.683 278.998 142.374 278.162 143.226L265.953 155.671C265.118 156.522 266.426 157.831 267.261 156.98Z"
            fill="#E6E6E6"
          />
          <path
            d="M274.63 160.487C278 157.468 280.928 153.972 283.326 150.136C283.959 149.123 282.358 148.194 281.728 149.202C279.41 152.911 276.579 156.261 273.322 159.179C272.433 159.976 273.745 161.28 274.63 160.487Z"
            fill="#E6E6E6"
          />
          <path
            d="M281.272 164.684C284.34 161.287 286.951 157.495 289.007 153.405C289.541 152.344 287.945 151.406 287.409 152.471C285.423 156.423 282.928 160.093 279.964 163.376C279.167 164.258 280.472 165.571 281.272 164.684Z"
            fill="#E6E6E6"
          />
        </g>
        <path
          d="M311.53 276.311C312.804 276.391 313.509 274.808 312.544 273.885L312.449 273.504C312.461 273.474 312.474 273.443 312.487 273.413C313.775 270.34 318.143 270.362 319.421 273.438C320.555 276.169 321.999 278.905 322.355 281.792C322.514 283.067 322.442 284.365 322.159 285.616C324.817 279.812 326.215 273.475 326.215 267.102C326.215 265.501 326.128 263.9 325.948 262.302C325.801 260.996 325.598 259.697 325.335 258.411C323.913 251.456 320.833 244.832 316.39 239.299C314.255 238.132 312.474 236.308 311.398 234.121C311.012 233.333 310.709 232.484 310.565 231.62C310.808 231.652 311.482 227.951 311.299 227.724C311.637 227.21 312.243 226.955 312.613 226.454C314.453 223.96 316.988 224.395 318.311 227.784C321.137 229.21 321.165 231.576 319.43 233.85C318.327 235.298 318.175 237.256 317.207 238.805C317.307 238.933 317.41 239.056 317.51 239.184C319.336 241.526 320.916 244.043 322.248 246.688C321.872 243.749 322.427 240.208 323.375 237.925C324.453 235.324 326.474 233.134 328.254 230.886C330.392 228.185 334.777 229.363 335.153 232.787C335.157 232.82 335.16 232.853 335.164 232.886C334.9 233.036 334.641 233.194 334.388 233.361C332.944 234.315 333.443 236.552 335.153 236.816L335.192 236.822C335.096 237.774 334.933 238.718 334.694 239.646C336.977 248.475 332.047 251.69 325.008 251.835C324.853 251.914 324.701 251.994 324.546 252.07C325.259 254.077 325.829 256.136 326.251 258.224C326.63 260.068 326.893 261.932 327.04 263.804C327.223 266.166 327.207 268.54 327.008 270.898L327.02 270.814C327.526 268.217 328.937 265.792 330.985 264.111C334.035 261.605 338.345 260.683 341.637 258.669C343.221 257.699 345.251 258.952 344.975 260.788L344.961 260.876C344.471 261.076 343.993 261.307 343.531 261.565C343.266 261.715 343.007 261.873 342.754 262.04C341.311 262.995 341.81 265.231 343.52 265.495L343.559 265.501C343.587 265.505 343.61 265.509 343.638 265.513C342.798 267.508 341.626 269.361 340.16 270.958C338.732 278.665 332.6 279.396 326.04 277.152H326.036C325.319 280.275 324.271 283.326 322.924 286.233H311.809C311.769 286.11 311.733 285.982 311.697 285.859C312.725 285.923 313.761 285.863 314.773 285.676C313.948 284.664 313.123 283.644 312.299 282.633C312.279 282.613 312.263 282.593 312.247 282.573C311.828 282.055 311.406 281.541 310.988 281.023L310.988 281.023C310.961 279.433 311.152 277.849 311.53 276.311Z"
          fill="#F2F2F2"
        />
        <path
          d="M-19 286.5C-19 286.777 -18.4724 287 -17.8154 287H343.815C344.472 287 345 286.777 345 286.5C345 286.223 344.472 286 343.815 286H-17.8154C-18.4724 286 -19 286.223 -19 286.5Z"
          fill="#CCCCCC"
        />
        <g filter="url(#filter3_d_3694_8732)">
          <path d="M235.432 281.703L228.116 281.702L224.636 253.492L235.433 253.493L235.432 281.703Z" fill="#FFB6B6" />
          <path
            d="M210.368 281.537C210.14 281.92 210.02 283.158 210.02 283.604C210.02 284.975 211.132 286.086 212.503 286.086H235.158C236.093 286.086 236.852 285.328 236.852 284.393V283.45C236.852 283.45 237.972 280.616 235.665 277.123C235.665 277.123 232.797 279.858 228.512 275.574L227.248 273.285L218.101 279.973L213.031 280.597C211.922 280.734 210.939 280.576 210.368 281.537Z"
            fill="black"
          />
          <path d="M302.983 267.27L296.752 271.102L279.003 248.897L288.199 243.242L302.983 267.27Z" fill="#FFB6B6" />
          <path
            d="M281.549 280.257C281.556 280.703 282.102 281.821 282.336 282.2C283.055 283.368 284.584 283.732 285.752 283.014L305.048 271.146C305.845 270.656 306.093 269.613 305.603 268.817L305.109 268.014C305.109 268.014 304.578 265.013 300.782 263.246C300.782 263.246 299.773 267.078 293.878 265.674L291.602 264.387L287.316 274.875L283.325 278.062C282.452 278.759 281.531 279.14 281.549 280.257Z"
            fill="black"
          />
          <path
            d="M257.004 149.761C256.642 148.182 256.669 146.649 257.009 145.378L252.601 130.561L259.778 128.615L263.476 143.856C264.334 144.844 265.026 146.208 265.388 147.787C266.215 151.395 265.009 154.761 262.694 155.306C260.378 155.851 257.831 153.368 257.004 149.761Z"
            fill="#FFB6B6"
          />
          <path
            d="M216.17 50.9892C216.17 50.9892 227.736 45.9563 234.194 53.2292C240.072 59.8489 252.005 79.7687 250.779 81.7068L262.526 137.2L253.819 139.882L230.721 76.0517L216.17 50.9892Z"
            fill="#2F3A79"
          />
          <path
            d="M203.433 133.228L209.392 202.733L223.793 267.272L239.187 265.783L231.738 195.286L236.298 132.635L203.433 133.228Z"
            fill="black"
          />
          <path
            d="M204.665 148.309L241.781 207.381L284.13 258.176L297.135 249.808L258.241 190.535C252.288 164.426 245.695 140.257 233.614 132.744L204.665 148.309Z"
            fill="black"
          />
          <path
            d="M206.831 148.598C205.09 148.598 203.404 147.984 202.03 146.82C200.185 145.256 199.224 142.976 199.393 140.564L202.631 109.508L201.394 75.5954L201.402 75.5587L205.246 57.1299C205.284 56.5442 205.407 55.9242 205.605 55.3288L211.283 38.2629C212.304 35.1933 215.163 33.1309 218.399 33.1309H223.42C225.934 33.1309 228.267 34.379 229.661 36.47L234.056 43.061C234.348 43.4989 234.594 43.9689 234.788 44.4582L244.491 68.9405C244.799 69.7177 244.974 70.5353 245.012 71.3703L248.022 139.316C248.122 141.571 247.215 143.73 245.532 145.238C243.86 146.738 241.629 147.401 239.416 147.059C226.746 145.103 215.657 146.703 208.584 148.39C208 148.529 207.412 148.598 206.831 148.598Z"
            fill="#2F3A79"
          />
          <path
            d="M205.419 81.0995L196.978 74.6456C196.978 74.6456 200.95 39.397 211.379 39.397C221.807 39.397 227.269 33.4395 227.269 33.4395C227.269 33.4395 264.513 85.5677 254.085 91.5252C243.657 97.4827 229.256 94.504 229.256 94.504L224.183 49.9726C223.56 47.6186 220.32 47.3637 219.336 49.5913L205.419 81.0995Z"
            fill="#CA373C"
          />
          <path
            d="M219.307 31.6119C227.279 31.6119 233.742 25.1509 233.742 17.1809C233.742 9.21095 227.279 2.75 219.307 2.75C211.335 2.75 204.873 9.21095 204.873 17.1809C204.873 25.1509 211.335 31.6119 219.307 31.6119Z"
            fill="#FFB6B6"
          />
          <path
            d="M230.738 28.0909C229.436 28.5769 227.44 29.3326 226.138 29.8187C224.923 27.3985 226.411 26.1427 226.566 23.4395C226.617 22.5374 226.747 21.6343 226.672 20.7338C226.598 19.8334 226.288 18.909 225.609 18.3132C224.569 17.4017 222.838 17.55 221.832 18.4979C220.826 19.4458 220.539 21.0122 220.951 22.3319C216.993 20.6214 214.436 16.1341 214.982 11.8582C213.8 11.3949 212.589 10.9255 211.32 10.89C210.051 10.8546 208.691 11.3387 208.015 12.4129C207.541 13.1661 207.446 14.1223 206.914 14.8357C206.049 15.995 204.18 16.0848 203.032 15.2055C201.884 14.3261 201.444 12.728 201.689 11.3028C201.934 9.87757 200.152 6.96906 201.15 5.92183C201.83 5.20743 205.208 6.21968 205.967 5.58948C206.659 5.01453 207.355 4.43767 208.118 3.96069C209.087 3.35524 210.16 2.91678 211.276 2.67041C212.332 2.43736 213.416 2.37615 214.496 2.31568C215.591 2.25429 217.107 0.0731585 218.203 0.0117658C221.429 -0.168977 224.312 1.77848 227.407 2.70564C230.502 3.63281 232.449 6.29529 234.162 9.03402C236.602 12.9351 235.773 17.2095 234.092 20.9397C233.677 21.8618 235.071 22.8307 234.864 23.8206C234.673 24.7408 233.81 25.4073 233.609 26.3254C233.436 27.1105 232.417 26.2009 232.174 26.9671C231.964 27.6282 231.346 28.0949 230.685 28.3059C230.024 28.517 229.317 28.5127 228.623 28.5064"
            fill="black"
          />
          <path
            d="M227.64 33.0703L228.148 33.4406L229.431 34.3742C233.287 37.1809 232.929 43.0398 228.759 45.3557L223.545 37.0292"
            fill="#CA373C"
          />
          <path
            d="M154.843 50.2438C156.145 51.1026 157.145 52.1841 157.753 53.2875L170.67 60.6858L166.969 66.7279L154.264 58.5726C153.01 58.4476 151.622 57.9539 150.321 57.0951C147.347 55.1331 145.948 52.009 147.197 50.117C148.446 48.2251 151.869 48.2818 154.843 50.2438Z"
            fill="#FFB6B6"
          />
          <path
            d="M215.62 42.4458C223.857 37.3952 232.135 48.9615 224.811 55.2633L224.786 55.2847L195.521 82.8029L160.497 65.512L163.96 56.1762L191.095 66.9224L211.45 45.7967C212.867 44.3784 214.261 43.2792 215.62 42.4458Z"
            fill="#2F3A79"
          />
        </g>
        <path
          d="M42.1282 88.3926C41.4478 88.3926 40.8945 88.9457 40.8945 89.626V108.744C40.8945 109.424 41.4478 109.977 42.1282 109.977C42.8087 109.977 43.362 109.424 43.362 108.744V89.626C43.362 88.9457 42.8087 88.3926 42.1282 88.3926Z"
          fill="black"
        />
        <path
          d="M54.2193 106.814C58.4653 106.814 61.9074 103.445 61.9074 99.2898C61.9074 95.1343 58.4653 91.7656 54.2193 91.7656C49.9733 91.7656 46.5312 95.1343 46.5312 99.2898C46.5312 103.445 49.9733 106.814 54.2193 106.814Z"
          fill="url(#paint0_radial_3694_8732)"
        />
        <path
          d="M115.851 96.7165H74.4693C73.0496 96.7165 71.8945 95.5617 71.8945 94.1424C71.8945 92.7231 73.0496 91.5684 74.4693 91.5684H115.851C117.271 91.5684 118.426 92.7231 118.426 94.1424C118.426 95.5617 117.271 96.7165 115.851 96.7165Z"
          fill="white"
        />
        <path
          d="M148.146 105.429H74.4693C73.0496 105.429 71.8945 104.275 71.8945 102.855C71.8945 101.436 73.0496 100.281 74.4693 100.281H148.146C149.565 100.281 150.72 101.436 150.72 102.855C150.72 104.275 149.565 105.429 148.146 105.429Z"
          fill="white"
        />
        <path
          d="M7.68808 147.503C11.9341 147.503 15.3762 144.135 15.3762 139.979C15.3762 135.824 11.9341 132.455 7.68808 132.455C3.44207 132.455 0 135.824 0 139.979C0 144.135 3.44207 147.503 7.68808 147.503Z"
          fill="url(#paint1_radial_3694_8732)"
        />
        <path
          d="M69.3199 137.406H27.938C26.5183 137.406 25.3633 136.251 25.3633 134.832C25.3633 133.413 26.5183 132.258 27.938 132.258H69.3199C70.7396 132.258 71.8946 133.413 71.8946 134.832C71.8946 136.251 70.7396 137.406 69.3199 137.406Z"
          fill="white"
        />
        <path
          d="M79.8961 172.179C84.1421 172.179 87.5842 168.811 87.5842 164.655C87.5842 160.5 84.1421 157.131 79.8961 157.131C75.6501 157.131 72.208 160.5 72.208 164.655C72.208 168.811 75.6501 172.179 79.8961 172.179Z"
          fill="url(#paint2_radial_3694_8732)"
        />
        <path
          d="M173.823 170.793H100.146C98.7268 170.793 97.5718 169.638 97.5718 168.219C97.5718 166.799 98.7268 165.645 100.146 165.645H173.823C175.243 165.645 176.398 166.799 176.398 168.219C176.398 169.638 175.243 170.793 173.823 170.793Z"
          fill="white"
        />
        <path
          d="M155.621 31.4898C159.867 31.4898 163.309 28.1211 163.309 23.9656C163.309 19.8101 159.867 16.4414 155.621 16.4414C151.375 16.4414 147.933 19.8101 147.933 23.9656C147.933 28.1211 151.375 31.4898 155.621 31.4898Z"
          fill="url(#paint3_radial_3694_8732)"
        />
        <path
          d="M297.135 157.628C301.381 157.628 304.823 154.26 304.823 150.104C304.823 145.949 301.381 142.58 297.135 142.58C292.889 142.58 289.447 145.949 289.447 150.104C289.447 154.26 292.889 157.628 297.135 157.628Z"
          fill="url(#paint4_radial_3694_8732)"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_3694_8732"
          x="112.303"
          y="3.50586"
          width="69.9966"
          height="67.0332"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="6" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3694_8732" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3694_8732" result="shape" />
        </filter>
        <filter
          id="filter1_d_3694_8732"
          x="123.406"
          y="8.43945"
          width="69.9966"
          height="67.0332"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="6" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3694_8732" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3694_8732" result="shape" />
        </filter>
        <filter
          id="filter2_d_3694_8732"
          x="244.927"
          y="123.146"
          width="69.9966"
          height="67.0332"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="6" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3694_8732" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3694_8732" result="shape" />
        </filter>
        <filter
          id="filter3_d_3694_8732"
          x="136.74"
          y="-6"
          width="179.114"
          height="306.086"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3694_8732" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3694_8732" result="shape" />
        </filter>
        <radialGradient
          id="paint0_radial_3694_8732"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(54.2193 99.2898) rotate(90) scale(7.52419 7.68808)"
        >
          <stop stop-color="#5766BD" />
          <stop offset="1" stop-color="#2F3A79" />
        </radialGradient>
        <radialGradient
          id="paint1_radial_3694_8732"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(7.68808 139.979) rotate(90) scale(7.52419 7.68808)"
        >
          <stop stop-color="#5766BD" />
          <stop offset="1" stop-color="#2F3A79" />
        </radialGradient>
        <radialGradient
          id="paint2_radial_3694_8732"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(79.8961 164.655) rotate(90) scale(7.52419 7.68808)"
        >
          <stop stop-color="#5766BD" />
          <stop offset="1" stop-color="#2F3A79" />
        </radialGradient>
        <radialGradient
          id="paint3_radial_3694_8732"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(155.621 23.9656) rotate(90) scale(7.52419 7.68808)"
        >
          <stop stop-color="#5766BD" />
          <stop offset="1" stop-color="#2F3A79" />
        </radialGradient>
        <radialGradient
          id="paint4_radial_3694_8732"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(297.135 150.104) rotate(90) scale(7.52419 7.68807)"
        >
          <stop stop-color="#5766BD" />
          <stop offset="1" stop-color="#2F3A79" />
        </radialGradient>
        <clipPath id="clip0_3694_8732">
          <rect width="345" height="287" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const SearchIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20">
      <g id="Search_icon" data-name="Search icon" transform="translate(0.001 0)">
        <path
          id="Ellipse_642"
          data-name="Ellipse 642"
          d="M9,1.5A7.5,7.5,0,1,0,16.5,9,7.508,7.508,0,0,0,9,1.5M9,0A9,9,0,1,1,0,9,9,9,0,0,1,9,0Z"
          transform="translate(-0.001 0)"
          fill="#333"
        />
        <path
          id="Ellipse_643"
          data-name="Ellipse 643"
          d="M2.5,0A2.5,2.5,0,1,1,0,2.5,2.5,2.5,0,0,1,2.5,0Z"
          transform="translate(15.999 15)"
          fill="#333"
        />
      </g>
    </svg>
  );
};

export const NavigatorIcon = () => {
  return (
    <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_1410_7821)">
        <path
          d="M5.72727 2.86364C5.72727 1.28209 4.44518 0 2.86364 0C1.28209 0 0 1.28209 0 2.86364C0 4.44518 1.28209 5.72727 2.86364 5.72727C4.44518 5.72727 5.72727 4.44518 5.72727 2.86364Z"
          fill="#2F3A79"
          fill-opacity="0.8"
        />
        <path
          d="M15.4546 2.86364C15.4546 1.28209 14.1725 0 12.5909 0C11.0094 0 9.72729 1.28209 9.72729 2.86364C9.72729 4.44518 11.0094 5.72727 12.5909 5.72727C14.1725 5.72727 15.4546 4.44518 15.4546 2.86364Z"
          fill="#2F3A79"
          fill-opacity="0.8"
        />
        <path
          d="M25.1818 2.86364C25.1818 1.28209 23.8997 0 22.3182 0C20.7366 0 19.4545 1.28209 19.4545 2.86364C19.4545 4.44518 20.7366 5.72727 22.3182 5.72727C23.8997 5.72727 25.1818 4.44518 25.1818 2.86364Z"
          fill="#2F3A79"
          fill-opacity="0.8"
        />
        <path
          d="M5.72727 12.5909C5.72727 11.0094 4.44518 9.72726 2.86364 9.72726C1.28209 9.72726 0 11.0094 0 12.5909C0 14.1724 1.28209 15.4545 2.86364 15.4545C4.44518 15.4545 5.72727 14.1724 5.72727 12.5909Z"
          fill="#2F3A79"
          fill-opacity="0.8"
        />
        <path
          d="M15.4546 12.5909C15.4546 11.0094 14.1725 9.72726 12.5909 9.72726C11.0094 9.72726 9.72729 11.0094 9.72729 12.5909C9.72729 14.1724 11.0094 15.4545 12.5909 15.4545C14.1725 15.4545 15.4546 14.1724 15.4546 12.5909Z"
          fill="#2F3A79"
          fill-opacity="0.8"
        />
        <path
          d="M25.1818 12.5909C25.1818 11.0094 23.8997 9.72726 22.3182 9.72726C20.7366 9.72726 19.4545 11.0094 19.4545 12.5909C19.4545 14.1724 20.7366 15.4545 22.3182 15.4545C23.8997 15.4545 25.1818 14.1724 25.1818 12.5909Z"
          fill="#2F3A79"
          fill-opacity="0.8"
        />
        <path
          d="M5.72727 22.3182C5.72727 20.7366 4.44518 19.4545 2.86364 19.4545C1.28209 19.4545 0 20.7366 0 22.3182C0 23.8997 1.28209 25.1818 2.86364 25.1818C4.44518 25.1818 5.72727 23.8997 5.72727 22.3182Z"
          fill="#2F3A79"
          fill-opacity="0.8"
        />
        <path
          d="M15.4546 22.3182C15.4546 20.7366 14.1725 19.4545 12.5909 19.4545C11.0094 19.4545 9.72729 20.7366 9.72729 22.3182C9.72729 23.8997 11.0094 25.1818 12.5909 25.1818C14.1725 25.1818 15.4546 23.8997 15.4546 22.3182Z"
          fill="#2F3A79"
          fill-opacity="0.8"
        />
        <path
          d="M25.1818 22.3182C25.1818 20.7366 23.8997 19.4545 22.3182 19.4545C20.7366 19.4545 19.4545 20.7366 19.4545 22.3182C19.4545 23.8997 20.7366 25.1818 22.3182 25.1818C23.8997 25.1818 25.1818 23.8997 25.1818 22.3182Z"
          fill="#2F3A79"
          fill-opacity="0.8"
        />
      </g>
      <defs>
        <clipPath id="clip0_1410_7821">
          <rect width="26" height="25.1818" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const BackIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
      <path d="m3.86 8.753 5.482 4.796c.646.566 1.658.106 1.658-.753V3.204a1 1 0 0 0-1.659-.753l-5.48 4.796a1 1 0 0 0 0 1.506z"></path>
    </svg>
  );
};

export const Groups = () => {
  return (
    <svg width="30" height="27" viewBox="0 0 30 27" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.5 22.5C17.5 21.9477 17.9477 21.5 18.5 21.5C19.0523 21.5 19.5 21.9477 19.5 22.5C19.5 23.0523 19.0523 23.5 18.5 23.5C17.9477 23.5 17.5 23.0523 17.5 22.5Z"
        fill="black"
      />
      <path
        d="M14.5 17C14.5 16.4477 14.9477 16 15.5 16C16.0523 16 16.5 16.4477 16.5 17C16.5 17.5523 16.0523 18 15.5 18C14.9477 18 14.5 17.5523 14.5 17Z"
        fill="black"
      />
      <path
        d="M24 15.5C24 14.9477 24.4477 14.5 25 14.5C25.5523 14.5 26 14.9477 26 15.5C26 16.0523 25.5523 16.5 25 16.5C24.4477 16.5 24 16.0523 24 15.5Z"
        fill="black"
      />
      <path
        d="M14.5 12C14.5 11.4477 14.9477 11 15.5 11C16.0523 11 16.5 11.4477 16.5 12C16.5 12.5523 16.0523 13 15.5 13C14.9477 13 14.5 12.5523 14.5 12Z"
        fill="black"
      />
      <path
        d="M11.5 6.5V2C11.5 1.44772 11.0523 1 10.5 1H6.25M11.5 6.5H24C24.5523 6.5 25 6.94772 25 7.5V15.5M11.5 6.5V12M11.5 6.5H6.25M6.25 1H2C1.44772 1 1 1.44772 1 2V6.5M6.25 1V6.5M6.25 22.5H2C1.44772 22.5 1 22.0523 1 21.5V17M6.25 22.5H11.5M6.25 22.5V17M11.5 22.5V17M11.5 22.5H18.5M1 17H6.25M1 17V12M6.25 17H11.5M6.25 17V12M11.5 17V12M11.5 17H15.5M1 12H6.25M1 12V6.5M6.25 12H11.5M6.25 12V6.5M11.5 12H15.5M6.25 6.5H1"
        stroke="black"
        stroke-width="2"
      />
      <path
        d="M19 16.5C19 16.2239 19.2239 16 19.5 16H20.5C20.7761 16 21 16.2239 21 16.5V17.5C21 17.7761 20.7761 18 20.5 18H19.5C19.2239 18 19 17.7761 19 17.5V16.5Z"
        fill="black"
      />
      <path
        d="M19 11.5C19 11.2239 19.2239 11 19.5 11H20.5C20.7761 11 21 11.2239 21 11.5V12.5C21 12.7761 20.7761 13 20.5 13H19.5C19.2239 13 19 12.7761 19 12.5V11.5Z"
        fill="black"
      />
      <path
        d="M24.8333 25.6667V21.8333M24.8333 21.8333V18M24.8333 21.8333H21M24.8333 21.8333H28.6667"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const FilterIcon = () => (
  <svg width="19" height="21" viewBox="0 0 19 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M18 1H1V3.89453C1 4.18512 1.11156 4.47593 1.31131 4.6771L7.06369 10.7347C7.26344 10.9358 7.375 11.2266 7.375 11.5172V16.6471L11.625 20V11.5172C11.625 11.2266 11.7366 10.9358 11.9363 10.7347L17.6887 4.6771C17.7875 4.57509 17.866 4.45346 17.9194 4.31911C17.9729 4.18475 18.0003 4.04018 18 3.89453V1Z"
      stroke="black"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const DownloadIcon = () => (
  <svg width="21" height="18" viewBox="0 0 21 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1.46875 12C1.46875 14.76 3.70775 17 6.46875 17H14.4688C17.2297 17 19.4688 14.76 19.4688 12M7.46875 9.18994C8.20875 10.1799 9.06775 11.0701 10.0247 11.8401C10.1547 11.9501 10.3117 12 10.4688 12M10.4688 12C10.6311 12.0014 10.7886 11.9447 10.9128 11.8401C11.8698 11.0701 12.7287 10.1799 13.4688 9.18994M10.4688 12V1"
      stroke="black"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const Users = () => {
  return (
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.2222 16.3333H6.11111C4.75556 16.3333 3.45553 16.8718 2.49701 17.8303C1.53849 18.7889 1 20.0889 1 21.4444C1 22.1222 1.26924 22.7722 1.7485 23.2515C2.22776 23.7308 2.87778 24 3.55556 24H16.3333M20.1667 20.1667V16.3333M20.1667 16.3333V12.5M20.1667 16.3333H16.3333M20.1667 16.3333H24M16.3333 6.11111C16.3333 7.46666 15.7948 8.7667 14.8363 9.72522C13.8778 10.6837 12.5778 11.2222 11.2222 11.2222C9.86667 11.2222 8.56664 10.6837 7.60812 9.72522C6.6496 8.7667 6.11111 7.46666 6.11111 6.11111C6.11111 4.75556 6.6496 3.45553 7.60812 2.49701C8.56664 1.53849 9.86667 1 11.2222 1C12.5778 1 13.8778 1.53849 14.8363 2.49701C15.7948 3.45553 16.3333 4.75556 16.3333 6.11111Z"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const TeamsIcon = () => {
  return (
    <svg width="26" height="24" viewBox="0 0 26 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19 1.64197C20.4352 2.47237 21.4 4.0228 21.4 5.8C21.4004 6.64281 21.1788 7.47087 20.7575 8.20081C20.3362 8.93075 19.73 9.53684 19 9.95803M23.8 22.2784C24.5176 21.8644 25 21.088 25 20.2C25.0004 19.3572 24.7788 18.5291 24.3575 17.7992C23.9362 17.0693 23.33 16.4632 22.6 16.042M15.4 5.8C15.4 7.07304 14.8943 8.29394 13.9941 9.19412C13.0939 10.0943 11.873 10.6 10.6 10.6C9.32696 10.6 8.10606 10.0943 7.20588 9.19412C6.30571 8.29394 5.8 7.07304 5.8 5.8C5.8 4.52696 6.30571 3.30606 7.20588 2.40588C8.10606 1.50571 9.32696 1 10.6 1C11.873 1 13.0939 1.50571 13.9941 2.40588C14.8943 3.30606 15.4 4.52696 15.4 5.8ZM5.8 15.4H15.4C16.673 15.4 17.8939 15.9057 18.7941 16.8059C19.6943 17.7061 20.2 18.927 20.2 20.2C20.2 20.8365 19.9471 21.4469 19.4971 21.897C19.047 22.3471 18.4365 22.6 17.8 22.6H3.4C2.76348 22.6 2.15303 22.3471 1.70294 21.897C1.25285 21.4469 1 20.8365 1 20.2C1 18.927 1.50571 17.7061 2.40588 16.8059C3.30606 15.9057 4.52696 15.4 5.8 15.4Z"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const DashboardIcon = () => {
  return (
    <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1 5.2666C1 3.77327 1 3.02678 1.29067 2.45345C1.54667 1.96012 1.95466 1.54663 2.45599 1.29329C3.02666 0.999961 3.77333 1 5.26666 1H6.06667C7.56 1 8.30667 0.999961 8.87734 1.29329C9.37867 1.54663 9.78666 1.96012 10.0427 2.45345C10.3333 3.02678 10.3333 3.77327 10.3333 5.2666V6.06673C10.3333 7.56007 10.3333 8.30655 10.0427 8.87988C9.78666 9.37322 9.37867 9.78671 8.87734 10.04C8.30667 10.3334 7.56 10.3333 6.06667 10.3333H5.26666C3.77333 10.3333 3.02666 10.3334 2.45599 10.04C1.95466 9.78671 1.54667 9.37322 1.29067 8.87988C1 8.30655 1 7.56007 1 6.06673V5.2666ZM1 19.9333C1 18.4399 1 17.6935 1.29067 17.1201C1.54667 16.6268 1.95466 16.2133 2.45599 15.96C3.02666 15.6666 3.77333 15.6667 5.26666 15.6667H6.06667C7.56 15.6667 8.30667 15.6666 8.87734 15.96C9.37867 16.2133 9.78666 16.6268 10.0427 17.1201C10.3333 17.6935 10.3333 18.4399 10.3333 19.9333V20.7334C10.3333 22.2267 10.3333 22.9732 10.0427 23.5466C9.78666 24.0399 9.37867 24.4534 8.87734 24.7067C8.30667 25 7.56 25 6.06667 25H5.26666C3.77333 25 3.02666 25 2.45599 24.7067C1.95466 24.4534 1.54667 24.0399 1.29067 23.5466C1 22.9732 1 22.2267 1 20.7334V19.9333ZM15.6667 5.2666C15.6667 3.77327 15.6667 3.02678 15.9573 2.45345C16.2133 1.96012 16.6213 1.54663 17.1227 1.29329C17.6933 0.999961 18.44 1 19.9333 1H20.7333C22.2267 1 22.9733 0.999961 23.544 1.29329C24.0453 1.54663 24.4533 1.96012 24.7093 2.45345C25 3.02678 25 3.77327 25 5.2666V6.06673C25 7.56007 25 8.30655 24.7093 8.87988C24.4533 9.37322 24.0453 9.78671 23.544 10.04C22.9733 10.3334 22.2267 10.3333 20.7333 10.3333H19.9333C18.44 10.3333 17.6933 10.3334 17.1227 10.04C16.6213 9.78671 16.2133 9.37322 15.9573 8.87988C15.6667 8.30655 15.6667 7.56007 15.6667 6.06673V5.2666ZM15.6667 19.9333C15.6667 18.4399 15.6667 17.6935 15.9573 17.1201C16.2133 16.6268 16.6213 16.2133 17.1227 15.96C17.6933 15.6666 18.44 15.6667 19.9333 15.6667H20.7333C22.2267 15.6667 22.9733 15.6666 23.544 15.96C24.0453 16.2133 24.4533 16.6268 24.7093 17.1201C25 17.6935 25 18.4399 25 19.9333V20.7334C25 22.2267 25 22.9732 24.7093 23.5466C24.4533 24.0399 24.0453 24.4534 23.544 24.7067C22.9733 25 22.2267 25 20.7333 25H19.9333C18.44 25 17.6933 25 17.1227 24.7067C16.6213 24.4534 16.2133 24.0399 15.9573 23.5466C15.6667 22.9732 15.6667 22.2267 15.6667 20.7334V19.9333Z"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const ResourceIcon = () => {
  return (
    <svg width="25" height="26" viewBox="0 0 25 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.5 12.9985V25M12.5 12.9985L1.43444 7.17457M12.5 12.9985L18.0328 10.0801M12.5 25C12.7773 25 13.0558 24.9748 13.328 24.9116C13.9452 24.7979 14.5266 24.4693 15.6868 23.8377L20.8132 21.0332C21.9734 20.4015 22.5548 20.0857 22.9765 19.6435C23.3509 19.2393 23.632 18.7845 23.8045 18.2792C24 17.7107 24 17.0789 24 15.803V10.1939C24 8.91797 24 8.2862 23.8045 7.71771C23.7406 7.52821 23.6601 7.35143 23.5656 7.17457M12.5 25C12.2227 25 11.9442 24.9748 11.672 24.9116C11.0548 24.7979 10.4734 24.4693 9.31322 23.8377L4.18678 21.0332C3.02656 20.4015 2.44517 20.0857 2.0235 19.6435C1.65377 19.2512 1.37165 18.7864 1.1955 18.2792C1 17.7107 1 17.0789 1 15.803V10.1939C1 8.91797 1 8.2862 1.1955 7.71771C1.25939 7.52821 1.33988 7.35143 1.43444 7.17457M1.43444 7.17457C1.59161 6.88401 1.78967 6.60604 2.0235 6.35338C2.44517 5.91122 3.02656 5.59542 4.18678 4.96376L6.75 3.56149M18.0328 10.0801L23.5656 7.17457M18.0328 10.0801L6.75 3.56149M18.0328 10.0801V14.666M23.5656 7.17457C23.4045 6.87769 23.2066 6.60181 22.9765 6.35338C22.5548 5.91122 21.9734 5.59542 20.8132 4.96376L15.6868 2.15922C14.5266 1.52756 13.9452 1.19898 13.328 1.08528C12.782 0.971574 12.218 0.971574 11.672 1.08528C11.0548 1.19898 10.4734 1.52756 9.31322 2.15922L6.75 3.56149"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const BackArrowIcon = () => {
  return (
    <svg width="18" height="12" viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.35833 1C4.60935 2.29326 3.03515 3.80752 1.675 5.505C1.56182 5.64516 1.50006 5.81985 1.5 6M1.5 6C1.50006 6.18015 1.56182 6.35484 1.675 6.49499C3.03515 8.19248 4.60935 9.70674 6.35833 11M1.5 6H16.5"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const ApplicationIcon = () => {
  return (
    <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1 5.2666C1 3.77327 1 3.02678 1.29067 2.45345C1.54667 1.96012 1.95466 1.54663 2.45599 1.29329C3.02666 0.999961 3.77333 1 5.26666 1H6.06667C7.56 1 8.30667 0.999961 8.87734 1.29329C9.37867 1.54663 9.78666 1.96012 10.0427 2.45345C10.3333 3.02678 10.3333 3.77327 10.3333 5.2666V6.06673C10.3333 7.56007 10.3333 8.30655 10.0427 8.87988C9.78666 9.37322 9.37867 9.78671 8.87734 10.04C8.30667 10.3334 7.56 10.3333 6.06667 10.3333H5.26666C3.77333 10.3333 3.02666 10.3334 2.45599 10.04C1.95466 9.78671 1.54667 9.37322 1.29067 8.87988C1 8.30655 1 7.56007 1 6.06673V5.2666ZM1 19.9333C1 18.4399 1 17.6935 1.29067 17.1201C1.54667 16.6268 1.95466 16.2133 2.45599 15.96C3.02666 15.6666 3.77333 15.6667 5.26666 15.6667H6.06667C7.56 15.6667 8.30667 15.6666 8.87734 15.96C9.37867 16.2133 9.78666 16.6268 10.0427 17.1201C10.3333 17.6935 10.3333 18.4399 10.3333 19.9333V20.7334C10.3333 22.2267 10.3333 22.9732 10.0427 23.5466C9.78666 24.0399 9.37867 24.4534 8.87734 24.7067C8.30667 25 7.56 25 6.06667 25H5.26666C3.77333 25 3.02666 25 2.45599 24.7067C1.95466 24.4534 1.54667 24.0399 1.29067 23.5466C1 22.9732 1 22.2267 1 20.7334V19.9333ZM15.6667 5.2666C15.6667 3.77327 15.6667 3.02678 15.9573 2.45345C16.2133 1.96012 16.6213 1.54663 17.1227 1.29329C17.6933 0.999961 18.44 1 19.9333 1H20.7333C22.2267 1 22.9733 0.999961 23.544 1.29329C24.0453 1.54663 24.4533 1.96012 24.7093 2.45345C25 3.02678 25 3.77327 25 5.2666V6.06673C25 7.56007 25 8.30655 24.7093 8.87988C24.4533 9.37322 24.0453 9.78671 23.544 10.04C22.9733 10.3334 22.2267 10.3333 20.7333 10.3333H19.9333C18.44 10.3333 17.6933 10.3334 17.1227 10.04C16.6213 9.78671 16.2133 9.37322 15.9573 8.87988C15.6667 8.30655 15.6667 7.56007 15.6667 6.06673V5.2666ZM15.6667 19.9333C15.6667 18.4399 15.6667 17.6935 15.9573 17.1201C16.2133 16.6268 16.6213 16.2133 17.1227 15.96C17.6933 15.6666 18.44 15.6667 19.9333 15.6667H20.7333C22.2267 15.6667 22.9733 15.6666 23.544 15.96C24.0453 16.2133 24.4533 16.6268 24.7093 17.1201C25 17.6935 25 18.4399 25 19.9333V20.7334C25 22.2267 25 22.9732 24.7093 23.5466C24.4533 24.0399 24.0453 24.4534 23.544 24.7067C22.9733 25 22.2267 25 20.7333 25H19.9333C18.44 25 17.6933 25 17.1227 24.7067C16.6213 24.4534 16.2133 24.0399 15.9573 23.5466C15.6667 22.9732 15.6667 22.2267 15.6667 20.7334V19.9333Z"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const PLusIcon = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8 15V8M8 8V1M8 8H1M8 8H15"
        stroke="#2F3A79"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const RemoveIcon = () => {
  return (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.05025 10.9498L6 6.00008M6 6.00008L10.9497 1.05033M6 6.00008L1.05025 1.05033M6 6.00008L10.9497 10.9498"
        stroke="#2F3A79"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const FileUploadIcon = () => {
  return (
    <svg width="22" height="26" viewBox="0 0 22 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13 1.06962V2.44001C13 4.45601 13 5.464 13.3924 6.2344C13.7378 6.91156 14.2884 7.4622 14.9656 7.80761C15.736 8.20001 16.744 8.2 18.76 8.2H20.1304M13 1.06962C12.5272 1.00002 11.9632 1 11.0188 1H8.67999C5.99199 1 4.64801 1.00001 3.62081 1.52321C2.71723 1.98278 1.98278 2.71721 1.52321 3.62079C1.00001 4.64799 1 5.99199 1 8.67999V17.32C1 20.008 1.00001 21.352 1.52321 22.3792C1.98312 23.2825 2.71747 24.0169 3.62081 24.4768C4.64801 25 5.99199 25 8.67999 25H12.52C15.208 25 16.552 25 17.5792 24.4768C18.4823 24.0165 19.2165 23.2823 19.6768 22.3792C20.2 21.352 20.2 20.008 20.2 17.32V10.1812C20.2 9.2368 20.2 8.6728 20.1304 8.2M13 1.06962C13.1152 1.08642 13.2244 1.10679 13.3324 1.13319C13.822 1.25079 14.29 1.44399 14.7196 1.70679C15.2044 2.00439 15.6196 2.4196 16.45 3.25L17.95 4.75C18.7804 5.5804 19.1956 5.99558 19.4932 6.48038C19.756 6.90998 19.9492 7.37799 20.0668 7.86759C20.0932 7.97559 20.1136 8.0848 20.1304 8.2M10.6 19V11.8M10.6 11.8C10.4707 11.8 10.3452 11.8445 10.2448 11.926C9.4784 12.5467 8.7916 13.2597 8.2 14.0488M10.6 11.8C10.7293 11.8 10.8548 11.8445 10.9552 11.926C11.7216 12.5467 12.4084 13.2597 13 14.0488"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const defaultLogo = "https://cdn.simulanis.io/sso/logos/default_simulanis.png";

export const ThreeDotsIcon = () => (
  <svg width="5" height="26" viewBox="0 0 5 26" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.5 4C1.672 4 1 3.325 1 2.5C1 1.675 1.672 1 2.5 1C3.328 1 4 1.675 4 2.5C4 3.325 3.328 4 2.5 4ZM2.5 14.5C1.672 14.5 1 13.825 1 13C1 12.175 1.672 11.5 2.5 11.5C3.328 11.5 4 12.175 4 13C4 13.825 3.328 14.5 2.5 14.5ZM2.5 25C1.672 25 1 24.325 1 23.5C1 22.675 1.672 22 2.5 22C3.328 22 4 22.675 4 23.5C4 24.325 3.328 25 2.5 25Z"
      fill="black"
      stroke="black"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const InfoIcon = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.38916 13.8916C6.50472 13.8916 5.67106 13.7223 4.88818 13.3838C4.10954 13.0452 3.42188 12.5776 2.8252 11.981C2.22852 11.3843 1.7609 10.6966 1.42236 9.91797C1.08382 9.13509 0.914551 8.30143 0.914551 7.41699C0.914551 6.53255 1.08382 5.70101 1.42236 4.92236C1.7609 4.13949 2.2264 3.44971 2.81885 2.85303C3.41553 2.25635 4.10319 1.78874 4.88184 1.4502C5.66471 1.11165 6.49837 0.942383 7.38281 0.942383C8.26725 0.942383 9.10091 1.11165 9.88379 1.4502C10.6667 1.78874 11.3564 2.25635 11.9531 2.85303C12.5498 3.44971 13.0174 4.13949 13.356 4.92236C13.6945 5.70101 13.8638 6.53255 13.8638 7.41699C13.8638 8.30143 13.6945 9.13509 13.356 9.91797C13.0174 10.6966 12.5498 11.3843 11.9531 11.981C11.3564 12.5776 10.6667 13.0452 9.88379 13.3838C9.10514 13.7223 8.2736 13.8916 7.38916 13.8916ZM7.38916 12.8125C8.13818 12.8125 8.83854 12.6729 9.49023 12.3936C10.1462 12.1143 10.7196 11.7292 11.2104 11.2383C11.7056 10.7432 12.0907 10.1698 12.3657 9.51807C12.645 8.86637 12.7847 8.16602 12.7847 7.41699C12.7847 6.66797 12.645 5.96761 12.3657 5.31592C12.0864 4.66423 11.6992 4.09082 11.2041 3.5957C10.709 3.10059 10.1356 2.71549 9.48389 2.44043C8.83219 2.16113 8.13184 2.02148 7.38281 2.02148C6.63379 2.02148 5.93343 2.16113 5.28174 2.44043C4.63005 2.71549 4.05876 3.10059 3.56787 3.5957C3.07699 4.09082 2.69189 4.66423 2.4126 5.31592C2.13753 5.96761 2 6.66797 2 7.41699C2 8.16602 2.13753 8.86637 2.4126 9.51807C2.69189 10.1698 3.07699 10.7432 3.56787 11.2383C4.06299 11.7292 4.63639 12.1143 5.28809 12.3936C5.93978 12.6729 6.64014 12.8125 7.38916 12.8125ZM6.27832 10.9082C6.14714 10.9082 6.03711 10.8659 5.94824 10.7812C5.85938 10.6966 5.81494 10.5908 5.81494 10.4639C5.81494 10.3369 5.85938 10.2311 5.94824 10.1465C6.03711 10.0618 6.14714 10.0195 6.27832 10.0195H7.06543V7.10596H6.38623C6.25505 7.10596 6.14502 7.06364 6.05615 6.979C5.96729 6.89437 5.92285 6.78857 5.92285 6.66162C5.92285 6.53467 5.96729 6.42887 6.05615 6.34424C6.14502 6.2596 6.25505 6.21729 6.38623 6.21729H7.57959C7.7404 6.21729 7.86312 6.27018 7.94775 6.37598C8.03239 6.47754 8.07471 6.61507 8.07471 6.78857V10.0195H8.86182C8.993 10.0195 9.10303 10.0618 9.19189 10.1465C9.28076 10.2311 9.3252 10.3369 9.3252 10.4639C9.3252 10.5908 9.28076 10.6966 9.19189 10.7812C9.10303 10.8659 8.993 10.9082 8.86182 10.9082H6.27832ZM7.33203 5.15723C7.10352 5.15723 6.90885 5.07682 6.74805 4.91602C6.58724 4.75521 6.50684 4.56055 6.50684 4.33203C6.50684 4.09928 6.58724 3.90251 6.74805 3.7417C6.90885 3.58089 7.10352 3.50049 7.33203 3.50049C7.56478 3.50049 7.75944 3.58089 7.91602 3.7417C8.07682 3.90251 8.15723 4.09928 8.15723 4.33203C8.15723 4.56055 8.07682 4.75521 7.91602 4.91602C7.75944 5.07682 7.56478 5.15723 7.33203 5.15723Z"
      fill="black"
      fill-opacity="0.5"
    />
  </svg>
);

export const DeleteIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="red"
    className="bi bi-trash3"
    viewBox="0 0 16 16"
  >
    <path d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5M11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47M8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5" />
  </svg>
);

export const AddIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      class="bi bi-plus-lg"
      viewBox="0 0 16 16"
    >
      <path
        fill-rule="evenodd"
        d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2"
      />
    </svg>
  );
};

export const UploadIcon = () => {
  return (
    <svg width="22" height="18" viewBox="0 0 22 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1 12C1 14.76 3.48778 17 6.55556 17H15.4444C18.5122 17 21 14.76 21 12M7.66667 3.81008C8.48889 2.82008 9.44333 1.92994 10.5067 1.15994C10.6446 1.05531 10.8196 0.998642 11 1.00002M11 1.00002C11.1804 0.998642 11.3554 1.05531 11.4933 1.15994C12.5567 1.92994 13.5111 2.82008 14.3333 3.81008M11 1.00002V12"
        stroke="#333333"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const CircleLoading = () => {
  return (
    <svg viewBox="25 25 50 50">
      <circle r="20" cy="50" cx="50">
        {""}
      </circle>
    </svg>
  );
};

// NEW

export const OrgManageIcon = () => {
  return (
    <svg width="22" height="24" viewBox="0 0 22 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.26316 1V3.22932M6.26316 3.22932V5.19048M6.26316 3.22932C5.7952 3.28417 5.33652 3.40003 4.89894 3.57397C3.3515 4.21193 2.12207 5.43553 1.48105 6.9756C1.21368 7.61674 1.09579 8.35219 1.04211 9.38095M6.26316 3.22932C7.25368 3.09523 8.54947 3.09524 10.4737 3.09524C12.3979 3.09524 13.6937 3.09523 14.6842 3.22932M14.6842 1V3.22932M14.6842 3.22932V5.19048M14.6842 3.22932C15.1522 3.28417 15.6108 3.40003 16.0484 3.57397C17.5959 4.21193 18.8253 5.43553 19.4663 6.9756C19.7337 7.61674 19.8516 8.35219 19.9053 9.38095M19.9053 9.38095C19.9474 10.2065 19.9474 11.2195 19.9474 12.5238M19.9053 9.38095H1.04211M9.42105 21.9524C6.47789 21.9524 6.05999 21.9524 4.89894 21.4705C4.13313 21.1559 3.43712 20.6942 2.85067 20.1118C2.26421 19.5294 1.79881 18.8377 1.48105 18.0762C1 16.9133 1 15.4571 1 12.5238C1 11.2195 1 10.2065 1.04211 9.38095M15.9479 15.1406C16.2431 14.8529 16.3904 14.709 16.5602 14.655C16.7095 14.6071 16.8695 14.6071 17.0187 14.655C17.1885 14.709 17.3359 14.8529 17.6311 15.1406L17.7733 15.2789C17.9005 15.4032 17.9646 15.4656 18.0386 15.5103C18.1041 15.5499 18.1756 15.5792 18.2505 15.5974C18.3342 15.6179 18.4236 15.6188 18.6023 15.6207L18.8011 15.623C19.2142 15.6272 19.421 15.629 19.5791 15.7105C19.7184 15.7817 19.8318 15.8945 19.9033 16.0332C19.9852 16.1905 19.987 16.3963 19.9913 16.8075L19.9936 17.0053C19.9955 17.1832 19.9964 17.2721 20.017 17.3555C20.0352 17.43 20.0647 17.5012 20.1045 17.5664C20.1494 17.64 20.2121 17.7037 20.337 17.8304L20.4759 17.9719C20.765 18.2657 20.9096 18.4124 20.9639 18.5814C21.012 18.7299 21.012 18.8891 20.9639 19.0377C20.9096 19.2067 20.765 19.3534 20.4759 19.6471L20.337 19.7887C20.2121 19.9153 20.1494 19.9791 20.1045 20.0527C20.0647 20.1178 20.0352 20.1891 20.017 20.2636C19.9964 20.3469 19.9955 20.4359 19.9936 20.6137L19.9913 20.8116C19.987 21.2227 19.9852 21.4285 19.9033 21.5859C19.8318 21.7245 19.7184 21.8374 19.5791 21.9085C19.421 21.99 19.2142 21.9919 18.8011 21.9961L18.6023 21.9984C18.4236 22.0003 18.3342 22.0012 18.2505 22.0217C18.1756 22.0398 18.1041 22.0692 18.0386 22.1088C17.9646 22.1534 17.9005 22.2158 17.7733 22.3402L17.6311 22.4784C17.3359 22.7662 17.1885 22.91 17.0187 22.964C16.8697 23.012 16.7093 23.012 16.5602 22.964C16.3904 22.91 16.2431 22.7662 15.9479 22.4784L15.8056 22.3402C15.6784 22.2158 15.6143 22.1534 15.5404 22.1088C15.4746 22.0691 15.4032 22.0397 15.3285 22.0217C15.2447 22.0012 15.1554 22.0003 14.9767 21.9984L14.7778 21.9961C14.3647 21.9919 14.158 21.99 13.9998 21.9085C13.8605 21.8374 13.7471 21.7245 13.6756 21.5859C13.5938 21.4285 13.5919 21.2227 13.5877 20.8116L13.5853 20.6137C13.5835 20.4359 13.5825 20.3469 13.562 20.2636C13.5438 20.1892 13.5143 20.1181 13.4745 20.0527C13.4296 19.9791 13.3669 19.9153 13.242 19.7887L13.103 19.6471C12.8139 19.3534 12.6693 19.2067 12.6151 19.0377C12.5669 18.8893 12.5669 18.7297 12.6151 18.5814C12.6693 18.4124 12.8139 18.2657 13.103 17.9719L13.242 17.8304C13.3669 17.7037 13.4296 17.64 13.4745 17.5664C13.5142 17.5012 13.5437 17.43 13.562 17.3555C13.5825 17.2721 13.5835 17.1832 13.5853 17.0053L13.5877 16.8075C13.5919 16.3963 13.5938 16.1905 13.6756 16.0332C13.7471 15.8945 13.8605 15.7817 13.9998 15.7105C14.158 15.629 14.3647 15.6272 14.7778 15.623L14.9767 15.6207C15.1554 15.6188 15.2447 15.6179 15.3285 15.5974C15.4033 15.5792 15.4749 15.5499 15.5404 15.5103C15.6143 15.4656 15.6784 15.4032 15.8056 15.2789L15.9479 15.1406ZM16.317 18.8094C16.317 18.5524 16.5308 18.3438 16.789 18.3438C17.0472 18.3438 17.261 18.5524 17.261 18.8094C17.261 19.0664 17.0472 19.275 16.789 19.275C16.6645 19.2751 16.545 19.2263 16.4566 19.139C16.3681 19.0518 16.318 18.9333 16.317 18.8094Z"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const InvoiceIcon = () => {
  return (
    <svg width="26" height="25" viewBox="0 0 26 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19.6667 11.1382V21.4276C19.6667 22.8424 20.86 24 22.3333 24M19.6667 11.1382V3.38276C19.6667 2.81684 19.6667 2.53348 19.612 2.32769C19.5073 1.92408 19.2492 1.57353 18.8889 1.34484C18.5286 1.11614 18.0924 1.02605 17.6667 1.093C17.4507 1.11873 17.18 1.23483 16.6387 1.45349C16.312 1.59497 16.148 1.6589 15.984 1.71035C15.3333 1.91613 14.64 1.96771 13.9693 1.83909C13.7987 1.8005 13.628 1.76174 13.2867 1.65885L12.092 1.3373C11.4373 1.15724 11.1107 1.06753 10.7773 1.02894C10.4827 0.990352 10.184 0.990352 9.88934 1.02894C9.55601 1.06753 9.22933 1.15724 8.57467 1.3373L7.38001 1.65885C7.03867 1.76174 6.86799 1.8005 6.69733 1.83909C6.02666 1.96771 5.33332 1.91613 4.68266 1.71035C4.45968 1.63632 4.24113 1.55082 4.02799 1.45349C3.48666 1.23483 3.216 1.11873 3 1.093C2.57431 1.02605 2.13808 1.11614 1.77777 1.34484C1.41746 1.57353 1.15938 1.92408 1.05467 2.32769C1 2.53348 1 2.81684 1 3.38276V16.7972C1 19.3182 0.999996 20.5786 1.508 21.5432C1.956 22.3921 2.66933 23.0741 3.54799 23.5114C4.54666 24.0002 5.85334 24 8.46668 24H22.3333M19.6667 11.1382H22.8667C23.6133 11.1382 23.9867 11.138 24.272 11.2795C24.5252 11.4015 24.7299 11.6003 24.8547 11.8453C25 12.1154 25 12.4759 25 13.1962V21.4276C25 22.8424 23.8067 24 22.3333 24M15.6667 6.63647H5H9.58743C10.5978 6.63647 11.5667 7.03503 12.2812 7.74446C12.9956 8.45389 13.397 9.41608 13.397 10.4194C13.397 11.4226 12.9956 12.3848 12.2812 13.0943C11.5667 13.8037 10.5978 14.2023 9.58743 14.2023H5.38095L12.619 19.4983M5 10.4194H15.6667"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const FoldRight = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      className="bi bi-chevron-right"
      viewBox="0 0 16 16"
    >
      <path
        fill-rule="evenodd"
        d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708"
      />
    </svg>
  );
};

export const FoldDown = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      className="bi bi-chevron-down"
      viewBox="0 0 16 16"
    >
      <path
        fill-rule="evenodd"
        d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
      />
    </svg>
  );
};

export const EditIcon = () => {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.66667 13H13M1 13H2.818C3.07734 13 3.20734 13 3.32934 12.9733C3.438 12.9466 3.54133 12.9 3.636 12.8467C3.74333 12.78 3.83533 12.6866 4.01867 12.5L12.6673 3.81277C13.0207 3.45942 13.1087 2.91272 12.8393 2.47936C12.5127 1.95143 12.0728 1.5028 11.5513 1.16597C11.3497 1.03695 11.1101 0.980517 10.8721 1.00597C10.634 1.03142 10.4118 1.13721 10.242 1.30595L1.54 10.0465C1.36267 10.2265 1.27467 10.3132 1.21 10.4199C1.15333 10.5132 1.11067 10.6132 1.084 10.7132C1.05333 10.8332 1.05 10.9598 1.044 11.2132L1 13Z"
        stroke="black"
        stroke-opacity="0.5"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const PlanIcon = () => {
  return (
    <svg width="29" height="35" viewBox="0 0 29 35" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.25 9.99733H20.75M8.25 16.3952H20.75M8.25 22.7931H14.5M27 30.0383V12.2364C27 8.65362 27 6.86266 26.3187 5.48712C25.7198 4.28632 24.7633 3.31127 23.5875 2.70367C22.25 1.99991 20.5 2 17 2H12C8.49999 2 6.75001 1.99991 5.41251 2.70367C4.23595 3.31147 3.27969 4.28752 2.68126 5.48712C2.00001 6.86266 2 8.65362 2 12.2364V30.0383C2 31.2379 2.00001 31.8463 2.22032 32.2141C2.48126 32.662 2.93905 32.9655 3.44687 32.9975C3.87655 33.0295 4.40313 32.758 5.45626 32.2141C6.4047 31.7343 6.87969 31.4939 7.375 31.366C7.96407 31.206 8.57656 31.174 9.17969 31.2699C9.68594 31.3339 10.1812 31.5265 11.175 31.9103L11.8672 32.1821C12.8406 32.55 13.3281 32.7418 13.8297 32.8217C14.275 32.8857 14.725 32.8857 15.1703 32.8217C15.6719 32.7418 16.1594 32.55 17.1328 32.1821L17.825 31.9103C18.8188 31.5265 19.3141 31.3339 19.8203 31.2699C20.4234 31.174 21.0359 31.206 21.625 31.366C22.1203 31.4939 22.5953 31.7343 23.5437 32.2141C24.5969 32.758 25.1234 33.0295 25.5531 32.9975C25.8043 32.9783 26.0472 32.8974 26.2608 32.7608C26.4745 32.6243 26.6525 32.4367 26.7797 32.2141C27 31.8463 27 31.2379 27 30.0383Z"
        stroke="black"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const RightArrowIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      class="bi bi-chevron-right"
      viewBox="0 0 16 16"
    >
      <path
        fill-rule="evenodd"
        d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708"
      />
    </svg>
  );
};

export const CardIcon = () => {
  return (
    <svg width="23" height="19" viewBox="0 0 23 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M21.9688 6.5H1.96875M17.9688 10.5H14.9688M8.36874 17.5H15.5688C17.8088 17.5 18.9287 17.5 19.7847 17.064C20.5377 16.681 21.1498 16.069 21.5327 15.316C21.9687 14.46 21.9688 13.34 21.9688 11.1V7.90002C21.9688 5.66002 21.9687 4.54002 21.5327 3.68402C21.1498 2.93104 20.5377 2.31895 19.7847 1.93597C18.9287 1.49997 17.8088 1.5 15.5688 1.5H8.36874C6.12874 1.5 5.00876 1.49997 4.15276 1.93597C3.39977 2.31895 2.78773 2.93104 2.40475 3.68402C1.96875 4.54002 1.96875 5.66002 1.96875 7.90002V11.1C1.96875 13.34 1.96875 14.46 2.40475 15.316C2.78773 16.069 3.39977 16.681 4.15276 17.064C5.00876 17.5 6.12874 17.5 8.36874 17.5Z"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const CalenderIcon = () => {
  return (
    <svg width="21" height="23" viewBox="0 0 21 23" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.96875 1.5V3.63M6.96875 3.63V5.5M6.96875 3.63C6.47075 3.7 6.05374 3.79996 5.67274 3.95996C4.94523 4.26026 4.28402 4.70103 3.72688 5.25696C3.16975 5.81289 2.72762 6.47308 2.42575 7.19995C2.17175 7.81995 2.05975 8.52 2.00875 9.5M6.96875 3.63C7.90975 3.5 9.14075 3.5 10.9688 3.5C12.7967 3.5 14.0278 3.5 14.9688 3.63M14.9688 1.5V3.63M14.9688 3.63V5.5M14.9688 3.63C15.4667 3.7 15.8838 3.79996 16.2648 3.95996C16.9923 4.26026 17.6535 4.70103 18.2106 5.25696C18.7678 5.81289 19.2099 6.47308 19.5117 7.19995C19.7657 7.81995 19.8778 8.52 19.9288 9.5M19.9288 9.5C19.9688 10.29 19.9688 11.26 19.9688 12.5C19.9688 15.3 19.9687 16.69 19.5117 17.8C19.2099 18.5269 18.7678 19.1871 18.2106 19.743C17.6535 20.299 16.9923 20.7397 16.2648 21.04C15.1618 21.5 13.7648 21.5 10.9688 21.5C8.17275 21.5 6.77574 21.5 5.67274 21.04C4.94523 20.7397 4.28402 20.299 3.72688 19.743C3.16975 19.1871 2.72762 18.5269 2.42575 17.8C1.96875 16.69 1.96875 15.3 1.96875 12.5C1.96875 11.26 1.96875 10.29 2.00875 9.5M19.9288 9.5H2.00875M6.97874 13.5H6.96875M6.97874 17.5H6.96875M10.9787 13.5H10.9688M10.9787 17.5H10.9688M14.9787 13.5H14.9688M14.9787 17.5H14.9688"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const SortIcon = () => {
  return (
    <svg width="24" height="20" viewBox="0 0 24 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1 13.17C2.55191 15.2688 4.36902 17.1578 6.40601 18.79C6.58001 18.93 6.79 19 7 19M13 13.17C11.4481 15.2688 9.63098 17.1578 7.59399 18.79C7.4258 18.9258 7.21618 18.9999 7 19M7 19V1V19Z"
        fill="#2F3A79"
      />
      <path
        d="M11 6.83002C12.5519 4.73123 14.369 2.8422 16.406 1.21002C16.5742 1.07421 16.7838 1.00007 17 1M23 6.83002C21.4481 4.73123 19.631 2.8422 17.594 1.21002C17.4258 1.07421 17.2162 1.00007 17 1M17 1V19V1Z"
        fill="#2F3A79"
      />
      <path
        d="M1 13.17C2.55191 15.2688 4.36902 17.1578 6.40601 18.79C6.58001 18.93 6.79 19 7 19M7 19C7.21618 18.9999 7.4258 18.9258 7.59399 18.79C9.63098 17.1578 11.4481 15.2688 13 13.17M7 19V1M11 6.83002C12.5519 4.73123 14.369 2.8422 16.406 1.21002C16.5742 1.07421 16.7838 1.00007 17 1M17 1C17.2162 1.00007 17.4258 1.07421 17.594 1.21002C19.631 2.8422 21.4481 4.73123 23 6.83002M17 1V19"
        stroke="#2F3A79"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
